<template>
  <div class="moblie_pay">
    <!--    选择运营商-->
    <van-popup get-container="body" v-model="carrierSelectionShow" :close-on-click-overlay="false">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <div class="moblie_pay_payment_account_popup_main_wait_amount">
            {{ $t('text_payable_amount') }}:<span>{{ countryInfo?.currencyCode }}</span> <span class="moblie_pay_payment_account_popup_main_wait_amount_num">{{
              formattedPaymentAmount
            }}</span>
          </div>
          <!-- <div class="paymentMethod">
            <div class="paymentMethod_title">Please select a payment method</div>
            <div class="paymentMethod_box">
              <div class="paymentMethod_item" :class="item.isSelect && 'paymentMethod_item_s'"
                   v-for="(item,index) in operatorList" @click="chooseOperator(index)" :key="index">
                <img class="paymentMethod_item_logo" :src="item.logo" alt="">
                <div class="paymentMethod_item_name">{{ item.name }}</div>

                <img v-if="item.isSelect" class="paymentMethod_item_true" src="@/assets/CI/true.png" alt="">
              </div>
            </div>
          </div> -->
          <div @click="carrierSelectionSubmit" class="moblie_pay_container_step_account_submit">
            <div class="moblie_pay_container_step_account_submit_text">
              {{ $t('text_confirm') }}
            </div>
            <img class="moblie_pay_container_step_account_submit_img" src="@/assets/cardPay_GH/submit.png"
                 alt="">
          </div>
          <div style="height: 20px;"></div>
        </div>
      </div>
    </van-popup>

    <!--    付款账号-->
    <van-popup get-container="body" v-model="paymentAccountShow"
               :safe-area-inset-bottom="true" :close-on-click-overlay="false">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <div class="moblie_pay_payment_account_popup_main_logo">
            <img
                class="moblie_pay_payment_account_popup_main_logo_img"
                :src="
                repaymentData?.configData?.logoFileUrl
                  ? repaymentData.configData.logoFileUrl
                  : countryInfoLogo
              "
                alt=""
            />
          </div>
          <div class="moblie_pay_payment_account_popup_main_title">
            {{ countryInfo?.enName === 'TH' ? $t('text_please_fill_payment_method_th') : (operatorList.length ? $t('text_please_fill_payment_method2') : $t('text_please_fill_payment_method')) }}
          </div>
          <div class="moblie_pay_payment_account_popup_main_wait_amount">
            {{ $t('text_payment_amount') }}:<span>{{ countryInfo?.currencyCode }}</span>
            <span
                class="moblie_pay_payment_account_popup_main_wait_amount_num"
            >{{ formattedPaymentAmount }}</span
            >
          </div>
          <template v-if="countryInfo?.enName === 'TH'">
            <div class="th_form_item">
              <div class="th_form_label">{{ $t('text_customer_name') }}<span class="required-star">*</span></div>
              <div class="th_form_input_box">
                <input
                    v-model="customerName"
                    class="th_form_input"
                    type="text"
                    :placeholder="$t('text_please_enter_customer_name')"
                />
              </div>
            </div>
            <div class="th_form_item">
              <div class="th_form_label">{{ $t('text_bank_name') }}<span class="required-star">*</span></div>
              <div class="th_form_input_box" @click="bankPopup = true">
                <input
                    class="th_form_input"
                    type="text"
                    readonly
                    :value="customerBankName"
                    :placeholder="$t('text_please_select_bank')"
                />
                <img class="th_form_input_arrow" src="@/assets/1119/arrow.png" alt="">
              </div>
            </div>
            <div class="th_form_item">
              <div class="th_form_label">{{ $t('text_payment_account_number') }}<span class="required-star">*</span></div>
              <div class="th_form_input_box">
                <input
                    v-model="paymentAccount"
                    class="th_form_input"
                    type="text"
                    :placeholder="$t('text_please_enter_payment_account_number')"
                />
              </div>
            </div>
          </template>
          <template v-else>
            <div class="paymentMethod" v-if="operatorList.length">
              <div class="paymentMethod_title">{{ $t('text_please_select_payment_method') }}</div>
              <div class="paymentMethod_box">
                <div class="paymentMethod_item" :class="item.isSelect && 'paymentMethod_item_s'"
                     v-for="(item,index) in operatorList" @click="chooseOperator(index)" :key="index">
                  <img v-if="item.logo" class="paymentMethod_item_logo" :src="item.logo" alt="">
                  <div class="paymentMethod_item_name">{{ item.name }}</div>

                  <img v-if="item.isSelect" class="paymentMethod_item_true" src="@/assets/CI/true.png" alt="">
                </div>
              </div>
            </div>
            <div class="moblie_pay_container_step_account">
              <div class="moblie_pay_container_step_account_input_box">
                <div class="moblie_pay_container_step_233">+{{ countryInfo?.phoneCode }}</div>
                <input
                    v-model="paymentAccount"
                    class="moblie_pay_container_step_account_input"
                    type="text"
                    :maxlength="phoneMaxLength"
                    :placeholder="$t('text_please_enter_your_actual_payment_account')"
                />
              </div>
            </div>
          </template>
          <div class="moblie_pay_container_step_pay_account" v-if="countryInfo?.enName !== 'TH'">
            <img
                class="moblie_pay_container_step_pay_account_img"
                src="@/assets/cardPay_NG/danger.png"
                alt=""
            />
            {{ $t('text_please_fill_your_payment') }}
            <br/>
            {{ $t('text_please_fill_your_payment2') }}
          </div>
          <div
              @click="paymentAccountSubmit"
              class="moblie_pay_container_step_account_submit"
          >
            <div class="moblie_pay_container_step_account_submit_text">
              {{ $t('text_confirm') }}
            </div>
            <img
                class="moblie_pay_container_step_account_submit_img"
                src="@/assets/cardPay_GH/submit.png"
                alt=""
            />
          </div>
          <div style="height: 20px;"></div>
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body" round v-model="bankPopup" position="bottom">
      <van-picker
          :confirm-button-text="$t('text_confirm')"
          :cancel-button-text="$t('text_return')"
          show-toolbar
          value-key="name"
          :columns="bankList"
          :default-index="0"
          @confirm="bankChange"
          @cancel="bankPopup = false"
      />
    </van-popup>

    <van-popup get-container="body" v-model="editAccountShow">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <div class="moblie_pay_payment_account_popup_main_title">{{ $t('text_modify_payment_account') }}</div>
          <div class="moblie_pay_payment_account_popup_main_cur_account">
            {{ $t('text_current_account') }}:<span>{{ repaymentData.userSubmitAccountNumber }}</span>
          </div>
          <div class="moblie_pay_container_step_account">
            <div class="moblie_pay_container_step_account_input_box">
              <div class="moblie_pay_container_step_233">+{{ countryInfo?.phoneCode }}</div>
              <input v-model="editAccountNumber" class="moblie_pay_container_step_account_input" type="text"
                     :maxlength="phoneMaxLength" :placeholder="$t('text_please_enter_your_actual_payment_account')">
            </div>
          </div>
          <div @click="editAccountSubmit" class="moblie_pay_container_step_account_submit">
            <div class="moblie_pay_container_step_account_submit_text">
              {{ $t('text_confirm') }}
            </div>
            <img class="moblie_pay_container_step_account_submit_img" src="@/assets/cardPay_GH/submit.png"
                 alt="">
          </div>
          <div style="height: 30px;"></div>
        </div>
        <div class="moblie_pay_payment_account_popup_close_box">
          <img class="moblie_pay_payment_account_popup_close" @click="editAccountShow = false"
               src="@/assets/cardPay_GH/close.png">
        </div>
      </div>
    </van-popup>


    <van-popup get-container="body" v-model="editAccountConfirmShow">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <div class="moblie_pay_payment_account_popup_main_title">
            <img class="moblie_pay_payment_account_popup_main_title_img" src="@/assets/cardPay_NG/danger.png" alt="">
            {{ $t('text_remind') }}
          </div>
          <div class="moblie_pay_payment_account_popup_main_collect_confirm_box">
            {{ $t('text_payment_account_change_once') }} <span>{{ editAccountNumber }}</span>?
          </div>
          <div class="moblie_pay_payment_account_popup_main_confirm_box">
            <div @click="submitEditTrxNo" class="moblie_pay_container_step_account_submit">
              <div class="moblie_pay_container_step_account_submit_text">
                {{ $t('text_confirm2') }}
              </div>
              <img class="moblie_pay_container_step_account_submit_img" src="@/assets/cardPay_GH/submit.png"
                   alt="">
            </div>
          </div>
          <div style="height: 30px;"></div>
        </div>
        <div class="moblie_pay_payment_account_popup_close_box">
          <img class="moblie_pay_payment_account_popup_close" @click="editAccountConfirmShow = false"
               src="@/assets/cardPay_GH/close.png">
        </div>
      </div>
    </van-popup>


    <van-popup get-container="body" v-model="collectionShow">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main" v-if="collectionDataStep == 0">
          <div class="moblie_pay_payment_account_popup_main_title">
            <img class="moblie_pay_payment_account_popup_main_title_img" src="@/assets/cardPay_NG/danger.png" alt="">
            No payment received
          </div>
          <div class="moblie_pay_payment_account_popup_main_collect_box">
            <div class="moblie_pay_payment_account_popup_main_collect_num">
              Please check whether your payment account and actual payment amount are correct.
            </div>
            <div class="moblie_pay_payment_account_popup_main_collect_total">
              Payment account:<span>{{ repaymentData.userSubmitAccountNumber }}</span>
              <div @click="editAccountShow = true" v-if="repaymentData.canEditAccountNumberNumber"
                   class="moblie_pay_payment_account_popup_main_collect_total_edit">
                <img class="moblie_pay_payment_account_popup_main_collect_total_edit_img"
                     src="@/assets/cardPay_GH/edit.png">Modify
              </div>
            </div>
          </div>
          <div style="height: 35px;"></div>
        </div>
        <div class="moblie_pay_payment_account_popup_main" v-if="collectionDataStep == 1">
          <div class="moblie_pay_payment_account_popup_main_title">{{ $t('text_get_results') }}</div>
          <div class="moblie_pay_payment_account_popup_main_collect_box">
            <div class="moblie_pay_payment_account_popup_main_collect_num">
              {{ collectionData.transactionNums }} {{ $t('text_transfer_received') }}
            </div>
            <div class="moblie_pay_payment_account_popup_main_collect_total">
              {{ $t('text_total_amount2') }}:<span>{{ countryInfo?.currencyCode }} </span><span class="moblie_pay_payment_account_popup_main_collect_total_amount">{{
                collectionData.collectedAmount
              }}</span>
              <div @click="collectionDetailShow = true"
                class="moblie_pay_payment_account_popup_main_collect_detail">
                {{ $t('text_detail') }}
              </div>
            </div>

          </div>
          <div style="height: 35px;"></div>
        </div>
        <div class="moblie_pay_payment_account_popup_close_box">
          <img class="moblie_pay_payment_account_popup_close" @click="collectionShow = false"
               src="@/assets/cardPay_GH/close.png">
        </div>
      </div>
    </van-popup>


    <van-popup get-container="body" v-model="collectionDetailShow">
      <div class="moblie_pay_payment_account_popup">
        <div class="moblie_pay_payment_account_popup_main">
          <div
              class="moblie_pay_payment_account_popup_main_title moblie_pay_payment_account_popup_main_detail_title">
            {{ $t('text_collection_details') }}
          </div>
          <div class="data-box">
            <van-row class="th-row">
              <van-col>{{ $t('text_order_number') }}</van-col>
              <van-col>{{ $t('text_debit_account') }}</van-col>
              <van-col>{{ $t('text_remittance_amount') }}</van-col>
              <van-col>{{ $t('text_payment_time') }}</van-col>
            </van-row>

            <van-row class="td-row" :style="{background:index %2==0?'#fff':'#f1f1f1'}"
                     v-for="(item,index) in collectionData.collectDetails" :key="index">
              <van-col class="common-ellipsis">{{ item.bankTransactionReference }}</van-col>
              <van-col class="common-ellipsis">{{ item.destinationAccountNumber }}</van-col>
              <van-col class="common-ellipsis">{{ item.amount }}</van-col>
              <van-col class="common-ellipsis">{{ item.transactionTime }}</van-col>

            </van-row>
          </div>
          <div style="height: 20px;"></div>
        </div>
        <div class="moblie_pay_payment_account_popup_close_box">
          <img class="moblie_pay_payment_account_popup_close" @click="collectionDetailShow = false"
               src="@/assets/cardPay_GH/close.png">
        </div>
      </div>
    </van-popup>
    <van-popup get-container="body" round v-model="operatorPopup" position="bottom">
      <van-picker
          :confirm-button-text="$t('text_confirm')"
          :cancel-button-text="$t('text_return')"
          show-toolbar
          value-key="text"
          :columns="operatorList"
          :default-index="operatorDefaultIndex"
          @confirm="operatorChange"
          @cancel="operatorPopup = false"
      />
    </van-popup>
  </div>
</template>

<script>
import indexJs from "./index.js";

export default {
  name: "Moblie",
  mixins: [indexJs],
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
.moblie_pay {
  position: relative;
  height: 100%;
  min-height: 100vh;
  background-color: #F5F5F5;

  .moblie_pay_header {
    width: 100%;
    height: 192px;
    padding-bottom: 16px;
    box-sizing: border-box;
    background: url("~@/assets/cardPay_GH/header_m.png") no-repeat;
    background-size: 100% 100%;

    .moblie_pay_header_content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      box-sizing: border-box;

      .moblie_pay_header_time_repayment {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;

      }

      .moblie_pay_header_time_box {

        .moblie_pay_header_time_title {
          margin-top: 40px;
          width: 172px;
          height: 26px;
          font-size: 11px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #EEEEEE;


          background: url("~@/assets/cardPay_GH/tansaction_m.png") no-repeat;
          background-size: 100% 100%;

          display: flex;
          align-items: center;
          justify-content: center;

        }

        .moblie_pay_header_time_info {
          display: flex;
          align-items: center;
          margin-top: 20px;
          margin-left: 15px;

          .moblie_pay_header_time_item {
            position: relative;
            background-size: 100% 100%;
            margin-right: 5px;
            display: flex;
            align-items: center;

            .moblie_pay_header_time {
              font-size: 14px;
              font-family: LucidaGrande;
              color: #EEEEEE;

              display: flex;
              align-items: center;

              .moblie_pay_header_time_item {
                width: 20px;
                height: 26px;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 2px;
                border: 0.5px solid rgba(255, 255, 255, 0.5);

                display: flex;
                align-items: center;
                justify-content: center;
              }

            }

            .moblie_pay_header_text {
              font-size: 12px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #CCCCCC;


            }

          }

          .moblie_pay_header_time_left {
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #CCCCCC;

            margin-right: 5px;
          }
        }
      }
    }

  }

  .moblie_pay_container {
    transform: translateY(-60px);
    margin: 5px auto;
    padding-top: 20px;
    padding-bottom: 53px;
    width: calc(100% - 20px);
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 15px;
    box-sizing: border-box;

    .moblie_pay_header_img_box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      .moblie_pay_header_img {
        width: 22px;
        height: 18px;
        margin-right: 5px;
      }

      .moblie_pay_header_text {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #404141;

        span {
          color: #f03024;
          margin-left: 10px;
        }
      }
    }

    .moblie_pay_container_step {
      display: flex;
      align-items: flex-start;
      margin-bottom: 5px;
      padding: 0 20px;

      .moblie_pay_container_step_label {
        width: 50px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #4B5367;
      }

      .moblie_pay_container_step_value {
        flex: 1;
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #7F7870;

        span {
          color: #DC811D;
        }
      }
    }

    .moblie_pay_container_step_item_box {
      border-left: 2px solid #CC8F4E;
      margin: 0 20px;
      padding: 15px;
      box-sizing: border-box;
      background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(236, 210, 161, 0.5) 100%);
      margin-bottom: 25px;

      .moblie_pay_container_step_item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }

        .moblie_pay_container_step_item_value {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #DC811D;

          span {
            font-size: 10px;
          }
        }

        .moblie_pay_container_step_item_img {
          width: 12px;
          height: 12px;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      .moblie_pay_container_step_transfer {
        .moblie_pay_container_step_item_value {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #948F8A;
          line-height: 20px;

          span {
            color: #DC811D;
            margin: 0 8px;
          }

          .moblie_pay_container_step_transfer_btn {
            cursor: pointer;
            padding: 3px 10px;
            box-sizing: border-box;
            background: rgba(51, 51, 51, 0.12);
            border-radius: 15px;
            margin-right: 8px;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 11px;
            color: #555555;

            display: flex;
            align-items: center;
            justify-content: center;

            .moblie_pay_container_step_transfer_btn_img {
              width: 11px;
              height: 11px;
              margin-right: 2px;
            }
          }

          .moblie_pay_container_step_item_value_width {
            width: 100%;
          }
        }
      }
    }

    .moblie_pay_container_step_account {
      margin-top: 10px;

      .moblie_pay_container_step_account_input_box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 8px;
        border: 1px solid #AAAAAA;
        padding: 0 6px;
        box-sizing: border-box;
        

        .moblie_pay_container_step_233 {
          width: 40px;
          color: #DC811D;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
        }
      }

      .moblie_pay_container_step_account_input {
        width: 100%;

        height: 40px;
        border: none;
        //padding-left: 10px;
        box-sizing: border-box;

        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        outline: none;

        &::placeholder {
          color: #BBBBBB;
        }

      }

      .moblie_pay_container_step_account_submit {
        margin-top: 15px;
        position: relative;
        width: 100%;
        height: 45px;
        background: linear-gradient(180deg, #ECD2A1 0%, #D4B077 100%);
        border-radius: 8px;

        font-size: 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #996A30;

        display: flex;
        align-items: center;
        justify-content: center;

        .moblie_pay_container_step_account_submit_text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
        }

        .moblie_pay_container_step_account_submit_img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(50%, -50%);
          width: 24px;
          height: 13px;
          z-index: 1;
        }

      }
    }


    .moblie_pay_container_result {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      padding: 12px 0;
      padding-left: 15px;
      line-height: 17px;
      background: #F2F2F2;
      width: 100%;

      .moblie_pay_container_result_info {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #7F7870;

        span {
          color: #DC811D;
          margin-left: 6px;
        }

        .moblie_pay_container_result_info_amount {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
        }

        .moblie_pay_container_result_info_content {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 6px;
        }

        .moblie_pay_container_result_info_btn {
          cursor: pointer;
          padding: 6px 10px;

          width: fit-content;
          box-sizing: border-box;
          background: rgba(51, 51, 51, 0.12);
          border-radius: 15px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #555555;
          margin-left: 8px;
        }
      }

    }

    .moblie_pay_container_result_submit {
      cursor: pointer;
      position: relative;
      position: relative;
      margin: 0 auto;
      margin-top: 15px;
      width: calc(100% - 40px);
      height: 45px;
      background: linear-gradient(180deg, #ECD2A1 0%, #D4B077 100%);
      border-radius: 8px;

      font-size: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #996A30;

      display: flex;
      align-items: center;
      justify-content: center;

      .moblie_pay_container_result_submit_text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
      }

      .moblie_pay_container_result_submit_img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(110%, -50%);
        width: 24px;
        height: 13px;
        z-index: 1;
      }

    }

    .moblie_pay_container_tips {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      box-sizing: border-box;
      margin-top: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 11px;
      color: #DA5B5B;
      padding: 0 20px;

      .moblie_pay_container_tips_img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
    }
  }
}

.moblie_pay_payment_account_popup {
  .moblie_pay_payment_account_popup_main {
    position: relative;
    width: 345px;
    background: #ffffff;
    border-radius: 15px;
    overflow: hidden;

    .moblie_pay_payment_account_popup_main_logo {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 30px;
      box-sizing: border-box;

      .moblie_pay_payment_account_popup_main_logo_img {
        height: 50px;
        border-radius: 8px;
      }
    }

    .paymentMethod {
      .paymentMethod_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #7F7870;
        margin-top: 25px;
        margin-left: 20px;
      }

      .paymentMethod_box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        margin-top: 15px;

        .paymentMethod_item {
          position: relative;
          width: 90px;
          height: 70px;
          background: #FFFFFF;
          box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          border: 1px solid #CCCCCC;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          margin: 0 6px;
          overflow: hidden;

          .paymentMethod_item_logo {
            width: 28px;
            height: 28px;
          }

          .paymentMethod_item_name {
            width: 100%;
            text-align: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #736B5A;
          }

          .paymentMethod_item_true {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 20px;
            height: 20px;
          }
        }

        .paymentMethod_item_s {
          background: rgba(246, 136, 52, 0.08);
          box-shadow: 0px 2px 10px 0px rgba(255, 112, 0, 0.2);
          border-radius: 8px;
          border: 1px solid #DBA95A;
        }
      }
    }


    .moblie_pay_payment_account_popup_main_title {
      padding-top: 30px;
      margin-left: 20px;
      margin-right: 20px;
      margin-bottom: 6px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #555555;

      display: flex;
      align-items: center;
      justify-content: flex-start;

      .moblie_pay_payment_account_popup_main_title_img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
      }
    }

    .moblie_pay_payment_account_popup_main_desc {
      margin-left: 20px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #7F7870;
      line-height: 17px;
    }

    .moblie_pay_payment_account_popup_main_detail_title {
      padding-top: 30px;
      margin-left: 20px;
      margin-bottom: 20px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #524535;
    }

    .moblie_pay_payment_account_popup_main_collect_box {
      margin-top: 20px;
      background: rgba(122, 122, 122, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 30px 12px;
      box-sizing: border-box;

      .moblie_pay_payment_account_popup_main_collect_num {
        width: 100%;
        text-align: left;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #7F7870;
      }

      .moblie_pay_payment_account_popup_main_collect_total {
        margin-top: 20px;
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #776A5A;

        span {
          color: #DC811D;
          margin-left: 6px;
        }

        .moblie_pay_payment_account_popup_main_collect_total_amount {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
        }

        .moblie_pay_payment_account_popup_main_collect_total_detail {
          cursor: pointer;
          padding: 3px 10px;
          box-sizing: border-box;
          background: rgba(51, 51, 51, 0.12);
          border-radius: 15px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #555555;
          margin-left: 8px;
        }

        .moblie_pay_payment_account_popup_main_collect_total_edit {
          cursor: pointer;
          padding: 6px 10px;
          box-sizing: border-box;
          background: rgba(51, 51, 51, 0.12);
          border-radius: 15px;
          margin-left: 8px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 11px;
          color: #555555;

          display: flex;
          align-items: center;
          justify-content: center;

          .moblie_pay_payment_account_popup_main_collect_total_edit_img {
            width: 11px;
            height: 11px;
            margin-right: 2px;
          }
        }
      }
    }

    .moblie_pay_payment_account_popup_main_collect_confirm_box {
      background: rgba(122, 122, 122, 0.1);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 15px 30px;
      box-sizing: border-box;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #7F7870;
      line-height: 17px;

      span {
        color: #DC811D;
        margin: 0 6px;
      }
    }

    .moblie_pay_payment_account_popup_main_cur_account {
      margin-left: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #7F7870;

      span {
        color: #DC811D;
        margin-left: 3px;
      }
    }

    .moblie_pay_payment_account_popup_main_wait_amount {
      margin-top: 20px;
      margin-left: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #555555;

      span {
        color: #DC811D;
        margin-left: 3px;
      }

      .moblie_pay_payment_account_popup_main_wait_amount_num {
        font-size: 16px;
      }
    }


    .moblie_pay_container_step_account {
      margin: 0 20px;
      margin-top: 20px;
      display: flex;
      align-items: center;

      .moblie_pay_container_step_account_label {
        width: 100px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #555555;
        flex-shrink: 0;
      }

      .required-star {
        color: #DC811D;
        margin-left: 2px;
      }

    }

    .th_form_item {
      margin: 0 20px;
      margin-top: 15px;

      .th_form_label {
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #555555;
        margin-bottom: 8px;
      }

      .th_form_input_box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 8px;
        border: 1px solid #AAAAAA;
        padding: 0 10px;
        box-sizing: border-box;

        .th_form_input {
          width: 100%;
          height: 40px;
          border: none;
          box-sizing: border-box;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #555555;
          outline: none;

          &::placeholder {
            color: #BBBBBB;
          }
        }

        .th_form_input_arrow {
          width: 16px;
          height: 16px;
          margin-left: 8px;
        }
      }
    }

    .moblie_pay_container_step_pay_account {
      margin-top: 15px;
      padding: 10px 0;
      background: rgba(218, 91, 91, 0.1);
      padding-left: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;

      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 11px;
      color: #DA5B5B;
      line-height: 16px;

      .moblie_pay_container_step_pay_account_img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }
    }


    .moblie_pay_container_step_account_submit {
      margin: 0 auto;
      margin-top: 15px;
      position: relative;
      width: 120px;
      height: 40px;
      background: linear-gradient(180deg, #ECD2A1 0%, #D4B077 100%);
      border-radius: 8px;

      font-size: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #996A30;

      display: flex;
      align-items: center;
      justify-content: center;

      .moblie_pay_container_step_account_submit_text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
      }

      .moblie_pay_container_step_account_submit_img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(50%, -50%);
        width: 24px;
        height: 13px;
        z-index: 1;
      }

    }

    .moblie_pay_payment_account_popup_main_confirm_box {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .moblie_pay_payment_account_popup_close_box {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .moblie_pay_payment_account_popup_close {
      cursor: pointer;
      width: 30px;
      height: 30px;
    }
  }
}


.data-box {
  width: 100%;

  .th-row {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
    box-sizing: border-box;
    background: rgba(122, 122, 122, 0.1);
    //border-radius: 15px 15px 0px 0px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #524535;
  }

  .td-row {
    padding: 6px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #7F7870;
  }

  ::v-deep .van-col {
    flex: 1;
    text-align: center;
  }

}

// 超出 1 行显示省略号
.common-ellipsis {
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  word-wrap: break-word;
  word-break: break-all;
  padding: 2px;
  box-sizing: border-box;
}

// 滚动条位置 --展示的是竖向
// /deep/.__bar-is-vertical {
// right: -1px !important;
// }
// // 隐藏横向滚动条
// /deep/.__bar-is-horizontal {
// display: none !important;
// }

// 滚动条位置 --展示横向
:deep(.__bar-is-vertical) {
  display: none !important;
}

// 隐藏横向滚动条
:deep(.__bar-is-horizontal) {
  bottom: -1px !important;
}
</style>
